import styled from "styled-components";

export const NameStyled = styled.div`
  h1 {
    font-size: 48px;
    width: max-content;
    position: relative;
    z-index: -100;
  }
  h1::before,
  h1::after {
    content: "";
    position: absolute;
    inset: 0;
  }

  h1::before {
    background-color: rgba(215, 215, 215);
    animation: typing 1500ms steps(25) 1s forwards;
  }

  h1::after {
    width: 0.2rem;
    background: black;
    animation: typing 1500ms steps(25) 1s forwards, blink 900ms infinite;
  }

  @keyframes typing {
    to {
      left: 100%;
    }
  }

  @keyframes blink {
    to {
      background: transparent;
    }
  }

  @media only screen and (max-width: 768px) {
    margin-top: 50px;
  }

  @media only screen and (max-width: 400px) {
    h1 {
      font-size: 36px;
    }
  }
`;
